import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./auth/AuthContext";
// Base reset first, then the two faces: fonts (self-hosted, ui/public/fonts)
// and the pair of scoped stylesheets. Both stylesheets are imported on every
// page rather than lazily per shell -- together they are a few KB after
// minification, and a stylesheet arriving after first paint would flash the
// wrong theme on the one navigation that crosses between them.
import "./styles/index.css";
import "./styles/fonts.css";
import "./styles/user.css";
import "./styles/admin.css";

const root = document.getElementById("root");
if (!root) throw new Error("missing #root element");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
